module.exports = __webpack_public_path__ + "country_config.f9954d8e081f3d8f1c0a4bd27b1ce246.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/country_config.svg
// module id = 349
// module chunks = 0